<template>
    <CenterBox
        :pageID="0"
    >
        <h1 style="text-align: center">{{ $t("sys_reset") }}</h1>
        <hr>
        <form @submit.prevent="submitForm">
<!--            <label for="licenceInput" class="form-label">{{ $t("sys_reset_subTitle") }}<br>{{ $t("sys_reset_subTitle2") }}</label>-->
<!--            <select v-model="mode" class="form-select">-->
<!--                <option value="0">Mode 0</option>-->
<!--                <option value="1">Mode 1</option>-->
<!--            </select>-->
            <input type="password" class="form-control" id="licenceInput"
                   aria-describedby="licenceHelp" :placeholder="this.$t('sys_reset_help')"
                   v-model="resetPassword"
            >
            <div id="licenceHelp" class="form-text">{{ $t("sys_reset_help") }}</div>
            <button class="btn btn-primary" style="width: 200px;">{{ $t('common_submit') }}</button>
        </form>

    </CenterBox>
</template>

<script>
import CenterBox from "@/components/routerViewLocation/CenterBox";

export default {
    name: "SystemResetView",
    components: {
        CenterBox
    },
    data(){
        return{
            mode: 0,
            resetPassword: '',
        }
    },
    methods: {
        async submitForm(){
            this.$store.commit('setIsTopLoading', true)
            await this.$mainApi.post('api/product/clear/', {
                "mode": this.mode,
                "pw": this.resetPassword
            })
                .then(response => {
                    if(response.data.status === 80){
                        this.$toast.success(this.$t('common_success'))
                    }else{
                        this.$swal.fire({
                            title: response.data.errors,
                            text: response.data.details ? JSON.stringify(response.data.details) : "",
                            icon: "error"
                        })
                    }
                })
            this.$store.commit('setIsTopLoading', false)
        },
    }
}
</script>

<style scoped>

</style>
